// max length 36 - 6(Von : (6 mandatory chars ))
export const MAX_IMAGE_TITLE_LENGTH = 30;
